import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { V2RoutingModule } from './v2-routing.module';
import { UiCommonModule } from './common/ui-common.module';

@NgModule({
  imports: [CommonModule, V2RoutingModule],
  declarations: [],
  exports: [UiCommonModule],
})
export class V2Module {}
